import { createFormatDate } from './createDateTimeFormatter';
import { getOrderedWeekdays } from './getOrderedWeekdays';
export function getWeekDayNames(locale = 'en-GB') {
    const formatDate = createFormatDate({
        locale,
        weekday: 'short',
        timeZone: 'UTC',
    });
    const days = getOrderedWeekdays().map((day) => {
        return new Date(`2017-01-0${day + 1}T00:00:00+00:00`);
    });
    return days.map((date) => formatDate(date));
}
//# sourceMappingURL=getWeekDayNames.js.map